import "../App.css";
import AboutSection from '../components/about-section/AboutSection';
import BannerSection from '../components/about-section/BannerSection';
import Footer from "../components/Footer";
import Hero from '../components/Hero';

function LandingPage() {
  return (
    <div className="main">
      <Hero />
      <AboutSection />
      <BannerSection />
      <Footer />
    </div>
  );
}

export default LandingPage;